export type Language = "en" | "pl" | "de";
export type TranslationDictionary = Record<string, string>;
export const LANGUAGE_SELECTION_EVENT = "fluxabee:language-selection";

const dictionaries: Partial<Record<Language, TranslationDictionary>> = {};
const pending: Partial<Record<Language, Promise<TranslationDictionary>>> = {};
const loaders = {
  en: () => import("@/content/locales/en"),
  pl: () => import("@/content/locales/pl"),
  de: () => import("@/content/locales/de"),
};

export const getLanguageDictionary = (language: Language) => dictionaries[language];

/** Resolve the dictionary before changing rendered language or hydrating SSG HTML. */
export const loadLanguage = (language: Language): Promise<TranslationDictionary> => {
  const dictionary = dictionaries[language];
  if (dictionary) return Promise.resolve(dictionary);
  if (pending[language]) return pending[language];

  const request = loaders[language]().then(
    ({ default: loaded }) => {
      dictionaries[language] = loaded;
      delete pending[language];
      return loaded;
    },
    (error: unknown) => {
      delete pending[language];
      throw error;
    },
  );
  pending[language] = request;
  return request;
};
